import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'

function Title({children}) {
    const { t } = useTranslation()

    const title = children? `${children} | ${t('Belsky Art Gallery')}` : t('Belsky Art Gallery')

    return (
        <Helmet>
            <title>{title}</title>
        </Helmet>
    )
}

export default Title